import { setCssVar } from 'quasar'
import { Preferences } from '@capacitor/preferences';
import { Platform } from 'quasar'

export function SAVE_PARAMS(state, [login, clients, register, user_profile, languages, attempts, layout, social_auth, use_complete_register]) {
    state.login = login
    state.clients = clients
    state.register = register
    state.user_profile = user_profile
    state.languages = languages
    state.attempts = attempts
    state.layout = layout
    state.social_auth = social_auth
    state.use_complete_register = use_complete_register

    if (Platform.is.ios) {
        Preferences.set({ key: 'login', value: JSON.stringify(login) })
        Preferences.set({ key: 'clients', value: JSON.stringify(clients) })
        Preferences.set({ key: 'register', value: JSON.stringify(register) })
        Preferences.set({ key: 'user_profile', value: JSON.stringify(user_profile) })
        Preferences.set({ key: 'languages', value: JSON.stringify(languages) })
        Preferences.set({ key: 'attempts', value: JSON.stringify(attempts) })
        Preferences.set({ key: 'layout', value: JSON.stringify(layout) })
        Preferences.set({ key: 'social_auth', value: JSON.stringify(social_auth) })
        Preferences.set({ key: 'use_complete_register', value: JSON.stringify(use_complete_register) })
    }

    setCssVar('primary', login.colors.primary)
    setCssVar('secondary', login.colors.secondary)
    setCssVar('accent', login.colors.tertiary)
}

export function SAVE_ATTEMPTS(state, [attempts]) {
    state.attempts = attempts
}

export function SAVE_ONBOARDING(state, onboarding) {
    state.use_complete_register = onboarding
}